import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import AccountBoxIconMui from "@material-ui/icons/AccountBox";
import AllInboxIconMui from "@material-ui/icons/AllInbox";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import CategoryIconMui from "@material-ui/icons/Category";
import DashboardRoundedIcon from "@material-ui/icons/DashboardRounded";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FindInPageOutlinedIcon from "@material-ui/icons/FindInPageOutlined";
import FormatListNumberedRtlIcon from "@material-ui/icons/FormatListNumberedRtl";
import InsertChartIcon from "@material-ui/icons/InsertChart";
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined";
import ListOutlinedIcon from "@material-ui/icons/ListOutlined";
import LiveHelpOutlinedIcon from "@material-ui/icons/LiveHelpOutlined";
import LocalShippingIconMui from "@material-ui/icons/LocalShipping";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import MoreOutlinedIcon from "@material-ui/icons/MoreOutlined";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsOutlined";
import PublishIconMui from "@material-ui/icons/Publish";
import QueueIconMui from "@material-ui/icons/Queue";
import ReceiptIconMui from "@material-ui/icons/ReceiptRounded";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import ShopOutlinedIcon from "@material-ui/icons/ShopOutlined";
import StarsIconMui from "@material-ui/icons/Stars";
import StyleIconMui from "@material-ui/icons/Style";
import TheatersIconMui from "@material-ui/icons/Theaters";
import ViewComfyIcon from "@material-ui/icons/ViewComfy";
import ViewCompactOutlinedIcon from "@material-ui/icons/ViewCompactOutlined";
import {
  EventIcon,
  ListAltIcon,
  LocalShippingIcon,
  PaymentsIcon,
  SettingsIcon,
  SpaceDashboardIcon,
  StorefrontIcon,
  TrendingUpIcon,
} from "../themeV2";
import AnalyticsIcon from "../theme/Icons/AnalyticsIcon";
import ReportingIcon from "../theme/Icons/ReportingIcon";
import { SECTION } from "../dashboard/sections";
import { CheckmarkIconImg } from "./iconComponents";

export { SECTION };

/**
 * All admin section IDs for convenience.
 */
export const ADMIN_SECTIONS = [
  SECTION.ADMIN_ORDERS,
  SECTION.ADMIN_CONTENT,
  SECTION.ADMIN_USERS,
  SECTION.ADMIN_MARKETING,
  SECTION.ADMIN_SYSTEM,
];

/**
 * Utility section IDs (FAQ, Log Out) — rendered last.
 */
export const UTILITY_SECTIONS = [SECTION.UTILITY];

/**
 * Icon component map — keyed by the iconName in each nav entry.
 */
const ICON_MAP = {
  // Shop Dashboard — themeV2 inline SVG icons
  MyDashboardIcon: SpaceDashboardIcon,
  ShopBuilderIcon: StorefrontIcon,
  SalesIcon: ListAltIcon,
  ManageEventsIcon: EventIcon,
  ReturnKitsIcon: LocalShippingIcon,
  GetPaidIcon: PaymentsIcon,
  ReferralIcon: TrendingUpIcon,
  AccountSettingsIcon: SettingsIcon,
  // Shop Dashboard — still MUI v4 (TC/agent/admin-specific)
  ViewCompactOutlined: ViewCompactOutlinedIcon,
  ReportingIcon,
  AnalyticsIcon,
  // User Account — MUI v4
  DashboardRounded: DashboardRoundedIcon,
  ListOutlined: ListOutlinedIcon,
  StarsIcon: StarsIconMui,
  FavoriteBorder: FavoriteBorderIcon,
  NotificationsOutlined: NotificationsOutlinedIcon,
  VerifiedUserOutlined: VerifiedUserOutlinedIcon,
  LiveHelpOutlined: LiveHelpOutlinedIcon,
  ExitToAppOutlined: ExitToAppOutlinedIcon,
  // Admin — MUI v4
  SearchOutlined: SearchOutlinedIcon,
  CheckmarkIcon: CheckmarkIconImg,
  LocalShipping: LocalShippingIconMui,
  AccountBalanceWalletOutlined: AccountBalanceWalletOutlinedIcon,
  AssignmentTurnedInOutlined: AssignmentTurnedInOutlinedIcon,
  FindInPageOutlined: FindInPageOutlinedIcon,
  CategoryIcon: CategoryIconMui,
  TheatersIcon: TheatersIconMui,
  AccountBoxIcon: AccountBoxIconMui,
  EmojiPeople: EmojiPeopleIcon,
  FormatListNumberedRtl: FormatListNumberedRtlIcon,
  LinkOutlined: LinkOutlinedIcon,
  AssignmentIndOutlined: AssignmentIndOutlinedIcon,
  CalendarToday: CalendarTodayIcon,
  AllInboxIcon: AllInboxIconMui,
  ReceiptIcon: ReceiptIconMui,
  MoreOutlined: MoreOutlinedIcon,
  ViewComfy: ViewComfyIcon,
  QueueIcon: QueueIconMui,
  InsertChart: InsertChartIcon,
  ShopOutlined: ShopOutlinedIcon,
  StyleIcon: StyleIconMui,
  PublishIcon: PublishIconMui,
  SettingsOutlined: SettingsOutlinedIcon,
};

/**
 * Resolves an icon name to its component.
 */
export const getIconComponent = (name) => ICON_MAP[name] ?? null;
